<article class="article">
  <header>
    <h4>Filters</h4>
    <button
      matButton="filled"
      class="active"
      [class.current-filter]="currentFilter === serviceLogicalStatus.ACTIVE"
      (click)="quickFilter(serviceLogicalStatus.ACTIVE)">
      {{ serviceLogicalStatus.ACTIVE }}
    </button>
    <button
      matButton="filled"
      class="inactive"
      [class.current-filter]="currentFilter === serviceLogicalStatus.INACTIVE"
      (click)="quickFilter(serviceLogicalStatus.INACTIVE)">
      {{ serviceLogicalStatus.INACTIVE }}
    </button>
    <button
      matButton="filled"
      class="updating"
      [class.current-filter]="currentFilter === serviceLogicalStatus.UPDATING"
      (click)="quickFilter(serviceLogicalStatus.UPDATING)">
      {{ serviceLogicalStatus.UPDATING }}
    </button>
    <button
      matButton="filled"
      class="deprecated"
      [class.current-filter]="currentFilter === serviceLogicalStatus.DEPRECATED"
      (click)="quickFilter(serviceLogicalStatus.DEPRECATED)">
      {{ serviceLogicalStatus.DEPRECATED }}
    </button>
    @if (currentFilter) {
      <button
        matButton="outlined"
        class="danger-button label-styles"
        (click)="quickFilter(null)">
        <mat-icon>close</mat-icon>
        Reset
      </button>
    }
  </header>
  <main>
    <div class="content">
      <cdk-virtual-scroll-viewport [itemSize]="10">
        <div
          class="services-list"
          cdkDropList
          (cdkDropListDropped)="drop($event)">
          @for (service of services; track service.guid) {
            <div
              class="services"
              cdkDrag
              cdkDragLockAxis="y">
              <div class="services__info">
                <button
                  matIconButton
                  cdkDragHandle>
                  <mat-icon class="text-muted">compress</mat-icon>
                </button>

                <div class="services__info-item name">
                  @if (service.image) {
                    <div class="img-preview">
                      <picture>
                        <img
                          [src]="service.image | sanitizeSrc"
                          [alt]="'Service icon'" />
                      </picture>
                    </div>
                  }
                  <div>
                    <span>{{ service.index }}.</span>
                    <strong [class.text-muted]="service.visibleTo.length === 0">
                      {{ service.name }}
                    </strong>
                  </div>
                </div>

                <div [ngClass]="service.status | serviceLogicalStatus">{{ service.status }}</div>

                <div class="services__info-item">
                  <span class="text-muted">Activation type</span>
                  <span>
                    {{ service.activationType ? (service.activationType | titlecase) : '-' }}
                  </span>
                </div>

                <div class="services__info-item date">
                  <span class="text-muted">Last activated</span>
                  <span>
                    {{ service.lastActivated ? (service.lastActivated | date: 'mediumDate') : '-' }}
                  </span>
                </div>

                <div class="services__info-item date">
                  <span class="text-muted">Last updated</span>
                  <span>
                    {{ service.lastUpdated ? (service.lastUpdated | date: 'mediumDate') : '-' }}
                  </span>
                </div>

                <div class="services__info-item">
                  <span class="text-muted">Hidden</span>
                  <span>
                    {{ service.isHidden ? 'Yes' : 'No' }}
                  </span>
                </div>

                <div class="services__info-item visibleTo">
                  <span class="text-muted">Visible to</span>
                  <div class="flex nowrap">
                    @for (offering of service.visibleTo; let last = $last; track offering) {
                      <span>{{ offering }}{{ last ? ';' : ',&nbsp;' }}</span>
                    } @empty {
                      <span>-</span>
                    }
                  </div>
                </div>
              </div>

              <div class="services__actions">
                <a
                  matButton
                  class="primary-button"
                  [routerLink]="[
                    '/',
                    'provider',
                    'admin',
                    'services',
                    service.guid,
                    'configuration',
                  ]">
                  <mat-icon>settings</mat-icon>
                  configuration
                </a>
              </div>
            </div>
          } @empty {
            <p class="no-data">No services found for current status</p>
          }
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </main>
</article>
